<template>
  <v-row class="fill-height">
    <v-col lg="5"
           class="fill-height d-flex justify-center align-center primary elevation-10">
      <v-fade-transition mode="out-in">
        <v-img src="@/assets/logo.png"
               contain
               :max-width="350"></v-img>
      </v-fade-transition>
    </v-col>
    <v-col lg="7" class="fill-height d-flex justify-center align-center">
      <validation-observer ref="observer" v-slot="{ passes }" style="width: 60%">
        <v-form @submit.prevent="passes(submit)">
          <v-card flat tile>
            <v-card-title class="text-h4 font-weight-bold" v-html="$t('loginForm.title')"></v-card-title>
            <v-card-subtitle class="caption mt-4">{{ $t('loginForm.subtitle') }}</v-card-subtitle>
            <v-card-text>
              <validation-provider rules="required" :name="$t('loginForm.login')" v-slot="{ errors }">
                <v-text-field class="my-6" v-model="form.email" type="email" :error-messages="errors"
                              :placeholder="$t('loginForm.login')"
                              dense :label="$t('loginForm.loginLabel')"></v-text-field>
              </validation-provider>
              <validation-provider rules="required" :name="$t('loginForm.password')" v-slot="{ errors }">
                <v-text-field class="my-6" v-model="form.password" type="password" :error-messages="errors"
                              :placeholder="$t('loginForm.password')"
                              dense :label="$t('loginForm.passwordLabel')"></v-text-field>
              </validation-provider>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn type="submit"
                     min-width="30%" color="primary" tile>{{ $t('loginForm.submit') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </validation-observer>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Main",
  data() {
    return {
      form: {
        email: null,
        password: null
      }
    }
  },
  methods: {
    submit () {
      this.$store.dispatch('setLoading', true)
      this.$http.post('api/v2/login', this.form)
          .then(() => {
            switch (this.$store.getters.GET_USER.role) {
              case 'user':
                this.$router.push({name: 'user.ticket'})
                return
              case 'admin':
                this.$router.push({name: 'admin.inbox'})
                return
            }
          })
          .finally(() => {
            this.$store.dispatch('setLoading', false)
          })
    }
  }
}
</script>

<style scoped>

</style>
